module.exports = __webpack_public_path__ + "img/applebees-flyer-logo.11df91da.png";